var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsSelfie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7C12.8781 7 13.9999 8.12207 13.9999 9.50012C13.9999 10.878 12.8781 12.0001 11.5 12.0001C10.1219 12.0001 9.00006 10.878 9.00006 9.50012C9.00006 8.12207 10.1219 7 11.5 7Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.2501C16 16.6641 15.664 17.0001 15.25 17.0001H7.75C7.336 17.0001 7 16.6641 7 16.2501V15.7501C7 14.233 8.23303 13 9.75006 13H13.2499C14.767 13 16 14.233 16 15.7501V16.2501Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99992 2H20.9999C22.6535 2 24 3.34648 24 5.00014V18.1999C24 19.8536 22.6535 21.2001 20.9999 21.2001H2.99992C1.34648 21.2001 0 19.8536 0 18.1999V5.00014C0 3.34648 1.34648 2 2.99992 2ZM20.9999 4.40007H2.99992C2.66879 4.40007 2.40007 4.66879 2.40007 5.00014V16.3268V19H21.5999V13.5189V5.00014C21.5999 4.66879 21.3312 4.40007 20.9999 4.40007Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsSelfie);
export default __webpack_public_path__ + "static/media/is_selfie.2fe7b6a9.svg";
export { ForwardRef as ReactComponent };